import { render, staticRenderFns } from "./step4.vue?vue&type=template&id=7cde6aa0&scoped=true&"
import script from "./step4.vue?vue&type=script&lang=js&"
export * from "./step4.vue?vue&type=script&lang=js&"
import style0 from "./step4.vue?vue&type=style&index=0&id=7cde6aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cde6aa0",
  null
  
)

export default component.exports